import io from 'socket.io-client';
import { singleMatchController } from '../controllers/singleMatchController';
import { detailMatchPageCommentsController } from '../controllers/detailMatchPageCommentsController';
import { detailMatchPageController } from '../controllers/detailMatchPageController';

// Spustenie WS komunikácie
export const initAllMatchesUpdates = (wrapper: HTMLElement) => {
  if (!wrapper) {
    return;
  }

  const matchElements = Array.from(wrapper.querySelectorAll<HTMLElement>('[data-match-id]'));

  if (matchElements.length === 0) {
    return;
  }

  setTimeout(() => {
    const socket = io('https://ws1.cncenter.cz');

    socket.on('connect', () => console.log('Successfully connected to the WebSocket server!'));
    socket.on('connect_error', (err: string) => console.error('Connection error:', err));
    socket.on('disconnect', (reason: string) => console.warn('Disconnected:', reason));

    // ID zápasov, ktoré su v stave live alebo sched
    const allMatchIds = matchElements
      .filter((el) => {
        const status = el.getAttribute('data-match-status');
        return status === 'live' || status === 'sched';
      })
      .map((el) => el.getAttribute('data-match-id'))
      .filter(Boolean);

    socket.on('select room', () => {
      // socket.emit('set match_short_events id', '359728');

      // Pre každé Match ID v poli zavoláme socket.emit
      allMatchIds.forEach((matchId) => {
        socket.emit('set match id', matchId);
      });
    });

    socket.on('new data', (msg: string) => {
      const data = JSON.parse(msg);

      const { match } = data;
      if (!match) return;

      singleMatchController(wrapper, data?.match, data?.tipsport_courses, data?.xml_data);
    });

    // Definícia funkcie na odpojenie socketu
    const disconnectAllMatchesUpdates = () => {
      console.log('Odpojujem WebSocket...');
      socket.disconnect();
    };

    // Odpojenie socketu pri zatvorení stránky
    window.addEventListener('beforeunload', disconnectAllMatchesUpdates);

    // referencia na disconnect funkciu, explicitne odpojiť socket.
    return { disconnect: disconnectAllMatchesUpdates };
  }, 5000);
};

// Spustenie WS komunikácie pro update detail online zápasu
export const initMatchDetailPageUpdates = (wrapper: HTMLElement) => {
  if (!wrapper) {
    return;
  }

  const matchElement = wrapper.querySelector<HTMLElement>('[data-match-id]');
  if (!matchElement) {
    return;
  }

  setTimeout(() => {
    const socket = io('https://ws1.cncenter.cz');

    socket.on('connect', () => console.log('Successfully connected to the WebSocket server!'));
    socket.on('connect_error', (err: string) => console.error('Connection error:', err));
    socket.on('disconnect', (reason: string) => console.warn('Disconnected:', reason));

    // Id zápasu
    const matchId = matchElement.getAttribute('data-match-id');

    socket.on('select room', () => {
      // socket.emit('set match id', '367843');

      // Pre Match ID zavoláme socket.emit
      socket.emit('set match id', matchId);
    });

    socket.on('new data', (msg: string) => {
      const data = JSON.parse(msg);

      const { match } = data;
      if (!match) return;

      detailMatchPageController(matchElement, match, data?.xml_data, data?.tipsport_courses);
      detailMatchPageCommentsController(data?.events);
    });

    // Definícia funkcie na odpojenie socket
    const disconnectAllMatchesUpdates = () => {
      console.log('Odpojujem WebSocket...');
      socket.disconnect();
    };

    // Odpojenie socketu pri zatvorení stránky
    window.addEventListener('beforeunload', disconnectAllMatchesUpdates);

    // referencia na disconnect funkciu, explicitne odpojiť socket.
    return { disconnect: disconnectAllMatchesUpdates };
  }, 5000);
};
